const FastChg = ({ ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <g clip-path="url(#clip0_8323_2103)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.2213 2.36475C7.31911 2.36475 6.53642 3.07708 6.53642 4.01798V4.85172H4.3933C4.17103 4.85172 3.95854 4.94308 3.80563 5.10439L0.853419 8.21879C0.710828 8.36921 0.631348 8.56859 0.631348 8.77586V14.1397C0.631348 14.587 0.993884 14.9495 1.4411 14.9495H3.1625C3.16204 14.9607 3.16181 14.972 3.16181 14.9833C3.16181 16.3622 4.27965 17.48 5.65853 17.48C7.03742 17.48 8.15526 16.3622 8.15526 14.9833C8.15526 14.9715 8.155 14.9599 8.15451 14.9483C8.17669 14.9491 8.19896 14.9496 8.2213 14.9496H10.7737C10.7732 14.9608 10.773 14.972 10.773 14.9833C10.773 16.3614 11.8893 17.48 13.268 17.48C14.6467 17.48 15.763 16.3614 15.763 14.9833C15.763 14.972 15.7628 14.9608 15.7623 14.9496H17.8477C18.295 14.9496 18.6575 14.587 18.6575 14.1398C18.6575 13.6926 18.295 13.3301 17.8477 13.3301H8.2213C8.1934 13.3301 8.17491 13.3199 8.16442 13.3098C8.15919 13.3047 8.15707 13.3007 8.15643 13.2993C8.15609 13.2985 8.15591 13.2981 8.15591 13.2963V4.01798C8.15591 4.01622 8.15607 4.01586 8.15642 4.01507C8.15706 4.01361 8.15919 4.00961 8.16442 4.00456C8.17491 3.99446 8.1934 3.98424 8.2213 3.98424H17.8477C18.295 3.98424 18.6575 3.62171 18.6575 3.17449C18.6575 2.72728 18.295 2.36475 17.8477 2.36475H8.2213ZM14.1442 14.9496H12.3918L12.3922 14.9629L12.3925 14.9833C12.3925 15.4685 12.7852 15.8605 13.268 15.8605C13.7508 15.8605 14.1435 15.4685 14.1435 14.9833C14.1435 14.972 14.1438 14.9608 14.1442 14.9496ZM4.78131 14.9833C4.78131 14.972 4.78107 14.9607 4.78061 14.9495H6.53645C6.53599 14.9607 6.53576 14.972 6.53576 14.9833C6.53576 15.4677 6.14299 15.8605 5.65853 15.8605C5.17407 15.8605 4.78131 15.4677 4.78131 14.9833ZM2.25084 9.09866L4.74146 6.47121H6.53576V13.33H2.25084V9.09866Z"
          fill="#1D1D1F"
        />
        <path
          d="M13.7848 7.31553C13.7848 6.86832 14.1473 6.50578 14.5946 6.50578H17.9454C18.3927 6.50578 18.7552 6.86832 18.7552 7.31553C18.7552 7.76274 18.3927 8.12528 17.9454 8.12528H14.5946C14.1473 8.12528 13.7848 7.76274 13.7848 7.31553Z"
          fill="#1D1D1F"
        />
        <path
          d="M14.5946 9.12484C14.1473 9.12484 13.7848 9.48737 13.7848 9.93458C13.7848 10.3818 14.1473 10.7443 14.5946 10.7443H19.8886C20.3358 10.7443 20.6983 10.3818 20.6983 9.93458C20.6983 9.48737 20.3358 9.12484 19.8886 9.12484H14.5946Z"
          fill="#1D1D1F"
        />
      </g>
      <defs>
        <clipPath id="clip0_8323_2103">
          <rect
            width="20.2437"
            height="20.2437"
            fill="white"
            transform="translate(0.598633 0.012207)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default FastChg
